import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Radio } from 'antd'

import { FlexColumn } from '../FlexboxReusables/FlexItems'
import { View } from '../../Routes/Course'

type ViewportOptionsProps = {
  selectedView: View
  setSelectedView: (view: View) => void
}

const ViewportOptions: React.FC<ViewportOptionsProps> = ({...props}) => {
  const { selectedView, setSelectedView } = props

  return (
    <ViewportSettingsColumn>
      <Radio.Group value={selectedView}>
        <Radio.Button value={View.EDITOR} onChange={() => setSelectedView(View.EDITOR)}>
          <FormattedMessage id='generic.courseContent' />
        </Radio.Button>
        <Radio.Button value={View.QUESTIONS} onChange={() => setSelectedView(View.QUESTIONS)}>
          <FormattedMessage id='generic.questions' />
        </Radio.Button>
      </Radio.Group>
    </ViewportSettingsColumn>
  )
}

export default ViewportOptions

const ViewportSettingsColumn = styled(FlexColumn)`
  align-items: flex-start;
  margin: 0 0 0 1em;
`